import { StudentDto } from './student.dto';

export class Student {
    id: string;
    schoolId: string;
    pathIds: string[];
    email: string;
    firstName: string;
    lastName: string;
    role: 'student';
    avatarSrc: string;
    description: string;

    constructor(data: StudentDto) {
        this.id = data.id;
        this.schoolId = data.schoolId;
        this.pathIds = data.pathIds ?? [];
        this.email = data.email;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.role = data.role;
        this.avatarSrc = data.avatarSrc;
        this.description = data.description;
    }
}
